import { Sustainability } from './Sustainability';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import RASuitabilityTestWizardActions from 'actions/RASuitabilityTestWizardActions';
import { actions as formActions } from 'react-redux-form';
import RASuitabilityTest from 'actions/RASuitabilityTest';
import stepsActions from 'actions/stepsActions';
import modalCancelActions from 'actions/modalCancelActions';

export const SustainabilityContainer = connect(
    state => ({
        userProfile: state.userProfile,
        RATestWizard: state.raSuitabilityTestWizard,
        immSuitabilityTest: state.raSuitabilityTest,
    }),
    dispatch => ({
        raTestActions: bindActionCreators(RASuitabilityTestWizardActions, dispatch),
        formActions: bindActionCreators(formActions, dispatch),
        raSuitabilityTest: bindActionCreators(RASuitabilityTest, dispatch),
        stepsActions: bindActionCreators(stepsActions, dispatch),
        modalCancelActions: bindActionCreators(modalCancelActions, dispatch),
    })
)(Sustainability);
